<template>
    <el-dialog
        class="customized"
        :visible.sync="customizedVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="Customized"
        :lock-scroll="false"
        :modal-append-to-body="true"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-row :gutter="10">
                <el-col :span="12" style="border-right: 1px solid #f7f7f7">
                    <el-input
                        v-model="keyword"
                        prefix-icon="el-icon-search"
                        placeholder="Place Input"
                        @change="metafiledsSelect"
                    ></el-input>
                    <el-scrollbar class="check-scroll">
                        <div class="check-wrap">
                            <el-checkbox-group
                                v-model="checkList"
                                @change="handelCheck"
                            >
                                <el-checkbox
                                    :label="item.key"
                                    v-for="item of this.metafiledList"
                                    :key="item.id"
                                    >{{ item.name }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                    </el-scrollbar>
                </el-col>
                <el-col :span="12">
                    <div class="gray-bar">Selected Conditions</div>
                    <div class="selected-wrap">
                        <el-scrollbar class="selected-scroll">
                            <div
                                class="sw-items"
                                v-for="(item, i) of this.showList"
                                :key="item.id"
                            >
                                <div class="sw-i__header">
                                    <span>{{ i + 1 }}. {{ item.key }}</span>
                                    <div>
                                        <el-button
                                            type="text"
                                            icon="el-icon-plus"
                                            @click="addItem(item, i)"
                                        ></el-button>
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            @click="removeItem(item, i)"
                                        ></el-button>
                                    </div>
                                </div>
                                <div class="sw-i__body">
                                    <el-tag
                                        v-for="Sitem of item.metafields_value"
                                        :key="Sitem.meta_id"
                                        >{{ Sitem.name }}</el-tag
                                    >
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                </el-col>
            </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="customizedVisible = false">
                Close
            </el-button>
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
export default {
    data() {
        return {
            keyword: "",
            loading: false,
            checkList: [],
            showList: [],
            metafiledList: [],
            emptyItem: {}
        };
    },
    methods: {
        metafiledsSelect() {
            cmofferApi.metafiledsSelect({
                keyword: this.keyword
            }, 'get').then((res) => {
                if (res) {
                    console.log(res);
                    this.metafiledList = res.data;
                    if (this.customizedList) {
                        this.checkList =
                            typeof this.customizedList == "string" &&
                            this.customizedList.split(",");
                        console.log("this.checkList", this.checkList);
                        this.handelCheck(this.checkList);
                    }
                }
            });
        },
        save() {
            this.$emit("saveMetafiled", this.showList);
            this.closeDialog();
        },
        closeDialog() {
            /* this.checkList = [];
            this.showList = []; */
            this.$emit("update:customizedVisible", false);
        },
        handelCheck(val) {
            this.showList = [];
            this.metafiledList.forEach((item) => {
                this.checkList.forEach((sItem) => {
                    if (item.key == sItem) {
                        this.showList.push({
                            id: item.id,
                            key: item.key,
                            metafields_value: item.metafields_value,
                        });
                    }
                });
            });
        },
        addItem(row, i) {
            console.log("row: ", row);
            this.emptyItem = JSON.parse(JSON.stringify(row));
            this.showList.splice(i, 0, row);
        },
        removeItem(row, i) {
            console.log("row: ", row);
            this.showList.splice(i, 1);
        },
    },
    components: {},
    props: {
        customizedVisible: Boolean,
        tableItem: Object,
        platform_id: Number,
        customizedList: Array,
    },
    computed: {
        ...mapState({}),
    },
    watch: {
        customizedVisible() {
            if (this.customizedVisible) {
                this.metafiledsSelect();
            }
        },
    },
};
</script>
<style lang="scss">
.customized {
    .container {
        width: 100%;
        font-size: 12px;
        div {
            box-sizing: border-box;
        }
        .check-scroll {
            margin-top: 20px;
            height: 400px;
            max-height: 500px;
            .check-wrap {
                padding-left: 10px;
                .el-checkbox {
                    margin-right: 0;
                    width: 100%;
                    .el-checkbox__label {
                        font-size: 12px;
                    }
                    & + .el-checkbox {
                        margin-top: 5px;
                    }
                }
            }
        }
        .gray-bar {
            width: 100%;
            font-size: 14px;
            padding: 11px 20px 11px 25px;
            background: #f7f7f7;
        }
        .selected-wrap {
            margin-top: 10px;
            padding: 10px 20px 10px 25px;
            .selected-scroll {
                height: 400px;
                max-height: 500px;
                .sw-items {
                    .sw-i__header {
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .sw-i__body {
                        margin-top: 10px;
                        .el-tag {
                            margin-bottom: 4px;
                        }
                    }
                    & + .sw-items {
                        margin-top: 10px;
                        padding-top: 10px;
                        border-top: 1px solid #f7f7f7;
                    }
                }
            }
        }
        .el-scrollbar {
            .el-scrollbar__wrap {
                overflow: hidden;
                overflow-y: scroll;
            }
        }
    }
}
</style>
